export interface SVGProps {
    className?: string;
    fill?: string;
    width?: number | string;
    height?: number | string;
    fillSub?: string;
}

export function DeleteIcon({ width = 14, height = 16, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.49992 0.5V1.33333H13.6666V3H12.8333V13.8333C12.8333 14.75 12.0833 15.5 11.1666 15.5H2.83325C1.91659 15.5 1.16659 14.75 1.16659 13.8333V3H0.333252V1.33333H4.49992V0.5H9.49992ZM2.83325 13.8333H11.1666V3H2.83325V13.8333ZM4.49992 4.66667H6.16658V12.1667H4.49992V4.66667ZM9.49992 4.66667H7.83325V12.1667H9.49992V4.66667Z"
                fill={fill}
            />
        </svg>
    );
}

export function PlusIcon({ width = 21, height = 20, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 21 20"
            fill="none"
        >
            <path
                d="M17.1654 10.833H11.332V16.6663H9.66536V10.833H3.83203V9.16634H9.66536V3.33301H11.332V9.16634H17.1654V10.833Z"
                fill="white"
            />
        </svg>
    );
}
export function ArrowLeftIcon({ width = 20, height = 20, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M11.9079 4.75592C11.5825 4.43048 11.0549 4.43048 10.7294 4.75592L6.65652 8.83277C6.0062 9.48377 6.00645 10.5386 6.6571 11.1892L10.7324 15.2645C11.0579 15.5899 11.5855 15.5899 11.911 15.2645C12.2364 14.9391 12.2364 14.4114 11.911 14.086L8.42287 10.5979C8.09744 10.2725 8.09744 9.74494 8.42287 9.41944L11.9079 5.93443C12.2334 5.609 12.2334 5.08136 11.9079 4.75592Z"
                fill="white"
            />
        </svg>
    );
}

export function ArrowLeftIconNew({ width = 20, height = 20, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M16.6667 9.16536H6.52504L11.1834 4.50703L10 3.33203L3.33337 9.9987L10 16.6654L11.175 15.4904L6.52504 10.832H16.6667V9.16536Z"
                fill="#797776"
            />
        </svg>
    );
}

export function ArrowLeftIconGray({ width = 20, height = 20, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M16.6667 9.16732H6.52504L11.1834 4.50898L10 3.33398L3.33337 10.0007L10 16.6673L11.175 15.4923L6.52504 10.834H16.6667V9.16732Z"
                fill="#797776"
            />
        </svg>
    );
}

export function ImageRounded({ width = 120, height = 120, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_11050_21175)">
                <rect
                    width="120"
                    height="120"
                    rx="60"
                    fill="#E1E2EC"
                />
                <rect
                    width="120"
                    height="120"
                    fill="#E1E2EC"
                />
                <path
                    d="M22.5 120C22.5 120 15 120 15 112.5C15 105 22.5 82.5 60 82.5C97.5 82.5 105 105 105 112.5C105 120 97.5 120 97.5 120H22.5Z"
                    fill="white"
                />
                <path
                    d="M60 75C72.4264 75 82.5 64.9264 82.5 52.5C82.5 40.0736 72.4264 30 60 30C47.5736 30 37.5 40.0736 37.5 52.5C37.5 64.9264 47.5736 75 60 75Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_11050_21175">
                    <rect
                        width="120"
                        height="120"
                        rx="60"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
export function CheckIcon({ width = 20, height = 21, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                d="M8.33333 14.1667L5 10.8334L6.16667 9.66671L8.33333 11.8334L13.8333 6.33337L15 7.50004L8.33333 14.1667Z"
                fill="white"
            />
        </svg>
    );
}

export function CloseIcon({ width = 20, height = 20, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.0058 5.17203C16.1576 5.01486 16.2416 4.80436 16.2397 4.58586C16.2378 4.36736 16.1502 4.15835 15.9957 4.00384C15.8412 3.84934 15.6321 3.7617 15.4137 3.7598C15.1952 3.7579 14.9847 3.84189 14.8275 3.99369L9.99999 8.82119L5.17249 3.99369C5.01532 3.84189 4.80482 3.7579 4.58632 3.7598C4.36782 3.7617 4.15881 3.84934 4.0043 4.00384C3.8498 4.15835 3.76216 4.36736 3.76026 4.58586C3.75836 4.80436 3.84235 5.01486 3.99415 5.17203L8.82165 9.99952L3.99415 14.827C3.91456 14.9039 3.85108 14.9959 3.8074 15.0975C3.76373 15.1992 3.74074 15.3085 3.73978 15.4192C3.73882 15.5298 3.7599 15.6396 3.8018 15.742C3.8437 15.8444 3.90558 15.9374 3.98382 16.0157C4.06207 16.0939 4.15511 16.1558 4.25752 16.1977C4.35994 16.2396 4.46967 16.2607 4.58032 16.2597C4.69097 16.2588 4.80032 16.2358 4.90199 16.1921C5.00366 16.1484 5.09561 16.085 5.17249 16.0054L9.99999 11.1779L14.8275 16.0054C14.9847 16.1572 15.1952 16.2412 15.4137 16.2393C15.6321 16.2374 15.8412 16.1497 15.9957 15.9952C16.1502 15.8407 16.2378 15.6317 16.2397 15.4132C16.2416 15.1947 16.1576 14.9842 16.0058 14.827L11.1783 9.99952L16.0058 5.17203Z"
                fill="#797776"
            />
        </svg>
    );
}

export function ProductIconActive({ width = 24, height = 24, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11 21.725V12.575L3 7.95V15.975C3 16.3417 3.0875 16.675 3.2625 16.975C3.4375 17.275 3.68333 17.5167 4 17.7L11 21.725ZM13 21.725L20 17.7C20.3167 17.5167 20.5625 17.275 20.7375 16.975C20.9125 16.675 21 16.3417 21 15.975V7.95L13 12.575V21.725ZM16.975 7.975L19.925 6.25L13 2.275C12.6833 2.09167 12.35 2 12 2C11.65 2 11.3167 2.09167 11 2.275L9.025 3.4L16.975 7.975ZM12 10.85L14.975 9.15L7.05 4.55L4.05 6.275L12 10.85Z"
                fill="white"
            />
        </svg>
    );
}
export function ProductIcon({ width = 24, height = 24, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11 19.425V12.575L5 9.1V15.95L11 19.425ZM13 19.425L19 15.95V9.1L13 12.575V19.425ZM11 21.725L4 17.7C3.68333 17.5167 3.4375 17.275 3.2625 16.975C3.0875 16.675 3 16.3417 3 15.975V8.025C3 7.65833 3.0875 7.325 3.2625 7.025C3.4375 6.725 3.68333 6.48333 4 6.3L11 2.275C11.3167 2.09167 11.65 2 12 2C12.35 2 12.6833 2.09167 13 2.275L20 6.3C20.3167 6.48333 20.5625 6.725 20.7375 7.025C20.9125 7.325 21 7.65833 21 8.025V15.975C21 16.3417 20.9125 16.675 20.7375 16.975C20.5625 17.275 20.3167 17.5167 20 17.7L13 21.725C12.6833 21.9083 12.35 22 12 22C11.65 22 11.3167 21.9083 11 21.725ZM16 8.525L17.925 7.425L12 4L10.05 5.125L16 8.525ZM12 10.85L13.95 9.725L8.025 6.3L6.075 7.425L12 10.85Z"
                fill="#313030"
            />
        </svg>
    );
}

export function IconEditNew({ width = 20, height = 20, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M4.5 5H15.5L14.7917 4.16667H5.20833L4.5 5ZM8.33333 10.625L10 9.79167L11.6667 10.625V6.66667H8.33333V10.625ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V5.4375C2.5 5.24306 2.53125 5.05556 2.59375 4.875C2.65625 4.69444 2.75 4.52778 2.875 4.375L3.91667 3.10417C4.06944 2.90972 4.26042 2.76042 4.48958 2.65625C4.71875 2.55208 4.95833 2.5 5.20833 2.5H14.7917C15.0417 2.5 15.2812 2.55208 15.5104 2.65625C15.7396 2.76042 15.9306 2.90972 16.0833 3.10417L17.125 4.375C17.25 4.52778 17.3437 4.69444 17.4062 4.875C17.4687 5.05556 17.5 5.24306 17.5 5.4375V8.33333C17.2083 8.33333 16.9201 8.35417 16.6354 8.39583C16.3507 8.4375 16.0833 8.52083 15.8333 8.64583V6.66667H13.3333V10.9375L11.7292 12.5417L10 11.6667L6.66667 13.3333V6.66667H4.16667V15.8333H10V17.5H4.16667ZM11.6667 17.5V14.9375L16.2708 10.3542C16.3958 10.2292 16.5347 10.1389 16.6875 10.0833C16.8403 10.0278 16.9931 10 17.1458 10C17.3125 10 17.4722 10.0312 17.625 10.0938C17.7778 10.1562 17.9167 10.25 18.0417 10.375L18.8125 11.1458C18.9236 11.2708 19.0104 11.4097 19.0729 11.5625C19.1354 11.7153 19.1667 11.8681 19.1667 12.0208C19.1667 12.1736 19.1389 12.3299 19.0833 12.4896C19.0278 12.6493 18.9375 12.7917 18.8125 12.9167L14.2292 17.5H11.6667ZM12.9167 16.25H13.7083L16.2292 13.7083L15.8542 13.3125L15.4583 12.9375L12.9167 15.4583V16.25ZM15.8542 13.3125L15.4583 12.9375L16.2292 13.7083L15.8542 13.3125Z"
                fill="#313030"
            />
        </svg>
    );
}

export const PointDot = ({ width = 14, height = 14 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="7"
                cy="7"
                r="6.5"
                fill="#2073F6"
                stroke="#0357DB"
            />
            <path
                d="M5.2327 10.7002V3.34019H7.4627C9.1027 3.34019 10.2727 3.9002 10.2727 5.5602C10.2727 7.1702 9.1027 7.9102 7.5027 7.9102H6.3927V10.7002H5.2327ZM6.3927 6.9802H7.3927C8.5727 6.9802 9.1327 6.5302 9.1327 5.5602C9.1327 4.5902 8.5227 4.2702 7.3527 4.2702H6.3927V6.9802Z"
                fill="white"
            />
        </svg>
    );
};

export const SpaceDashboardRounded = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H11V5H5V19ZM13 19H19V12H13V19ZM13 10H19V5H13V10Z"
                fill="#313030"
            />
        </svg>
    );
};

export const AdminPersonIconActive = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 18V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333 18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18Z"
                fill="white"
            />
        </svg>
    );
};

export const AdminPersonIcon = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 12C10.9 12 9.95833 11.6083 9.175 10.825C8.39167 10.0417 8 9.1 8 8C8 6.9 8.39167 5.95833 9.175 5.175C9.95833 4.39167 10.9 4 12 4C13.1 4 14.0417 4.39167 14.825 5.175C15.6083 5.95833 16 6.9 16 8C16 9.1 15.6083 10.0417 14.825 10.825C14.0417 11.6083 13.1 12 12 12ZM4 18V17.2C4 16.6333 4.14583 16.1125 4.4375 15.6375C4.72917 15.1625 5.11667 14.8 5.6 14.55C6.63333 14.0333 7.68333 13.6458 8.75 13.3875C9.81667 13.1292 10.9 13 12 13C13.1 13 14.1833 13.1292 15.25 13.3875C16.3167 13.6458 17.3667 14.0333 18.4 14.55C18.8833 14.8 19.2708 15.1625 19.5625 15.6375C19.8542 16.1125 20 16.6333 20 17.2V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18ZM6 18H18V17.2C18 17.0167 17.9542 16.85 17.8625 16.7C17.7708 16.55 17.65 16.4333 17.5 16.35C16.6 15.9 15.6917 15.5625 14.775 15.3375C13.8583 15.1125 12.9333 15 12 15C11.0667 15 10.1417 15.1125 9.225 15.3375C8.30833 15.5625 7.4 15.9 6.5 16.35C6.35 16.4333 6.22917 16.55 6.1375 16.7C6.04583 16.85 6 17.0167 6 17.2V18ZM12 10C12.55 10 13.0208 9.80417 13.4125 9.4125C13.8042 9.02083 14 8.55 14 8C14 7.45 13.8042 6.97917 13.4125 6.5875C13.0208 6.19583 12.55 6 12 6C11.45 6 10.9792 6.19583 10.5875 6.5875C10.1958 6.97917 10 7.45 10 8C10 8.55 10.1958 9.02083 10.5875 9.4125C10.9792 9.80417 11.45 10 12 10Z"
                fill="#313030"
            />
        </svg>
    );
};

export const CommunityManagementIcon = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12.36 6L12.76 8H18V14H14.64L14.24 12H7V6H12.36ZM14 4H5V21H7V14H12.6L13 16H20V6H14.4L14 4Z"
                fill="#313030"
            />
        </svg>
    );
};

export const CommunityManagementIconActive = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M14.4 6L14 4H5V21H7V14H12.6L13 16H20V6H14.4Z"
                fill="white"
            />
        </svg>
    );
};

export const DisplayManagementIcon = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11.99 18.54L4.62 12.81L3 14.07L12 21.07L21 14.07L19.37 12.8L11.99 18.54ZM12 16L19.36 10.27L21 9L12 2L3 9L4.63 10.27L12 16ZM12 4.53L17.74 9L12 13.47L6.26 9L12 4.53Z"
                fill="#313030"
            />
        </svg>
    );
};

export const DisplayManagementIconActive = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11.99 18.54L4.62 12.81L3 14.07L12 21.07L21 14.07L19.37 12.8L11.99 18.54ZM12 16L19.36 10.27L21 9L12 2L3 9L4.63 10.27L12 16Z"
                fill="white"
            />
        </svg>
    );
};

export const CustomerCenterIcon = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V16H6V2H21V19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V4H8V16H17V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM9 9V7H18V9H9ZM9 12V10H18V12H9ZM6 20H15V18H5V19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20ZM6 20H5H15H6Z"
                fill="#313030"
            />
        </svg>
    );
};

export const CustomerCenterIconActive = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V16H6V2H21V19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V4H8V16H17V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM9 9V7H18V9H9ZM9 12V10H18V12H9Z"
                fill="white"
            />
        </svg>
    );
};

export const EventCupIcon = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11 19V15.9C10.1833 15.7167 9.45417 15.3708 8.8125 14.8625C8.17083 14.3542 7.7 13.7167 7.4 12.95C6.15 12.8 5.10417 12.2542 4.2625 11.3125C3.42083 10.3708 3 9.26667 3 8V7C3 6.45 3.19583 5.97917 3.5875 5.5875C3.97917 5.19583 4.45 5 5 5H7C7 4.45 7.19583 3.97917 7.5875 3.5875C7.97917 3.19583 8.45 3 9 3H15C15.55 3 16.0208 3.19583 16.4125 3.5875C16.8042 3.97917 17 4.45 17 5H19C19.55 5 20.0208 5.19583 20.4125 5.5875C20.8042 5.97917 21 6.45 21 7V8C21 9.26667 20.5792 10.3708 19.7375 11.3125C18.8958 12.2542 17.85 12.8 16.6 12.95C16.3 13.7167 15.8292 14.3542 15.1875 14.8625C14.5458 15.3708 13.8167 15.7167 13 15.9V19H16C16.2833 19 16.5208 19.0958 16.7125 19.2875C16.9042 19.4792 17 19.7167 17 20C17 20.2833 16.9042 20.5208 16.7125 20.7125C16.5208 20.9042 16.2833 21 16 21H8C7.71667 21 7.47917 20.9042 7.2875 20.7125C7.09583 20.5208 7 20.2833 7 20C7 19.7167 7.09583 19.4792 7.2875 19.2875C7.47917 19.0958 7.71667 19 8 19H11ZM7 10.8V7H5V8C5 8.63333 5.18333 9.20417 5.55 9.7125C5.91667 10.2208 6.4 10.5833 7 10.8ZM12 14C12.8333 14 13.5417 13.7083 14.125 13.125C14.7083 12.5417 15 11.8333 15 11V5H9V11C9 11.8333 9.29167 12.5417 9.875 13.125C10.4583 13.7083 11.1667 14 12 14ZM17 10.8C17.6 10.5833 18.0833 10.2208 18.45 9.7125C18.8167 9.20417 19 8.63333 19 8V7H17V10.8Z"
                fill="#313030"
            />
        </svg>
    );
};

export const EventCupIconActive = ({ width = 24, height = 24 }: { width: number | string; height: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M7 10.8V7H5V8C5 8.63333 5.18333 9.20417 5.55 9.7125C5.91667 10.2208 6.4 10.5833 7 10.8ZM17 10.8C17.6 10.5833 18.0833 10.2208 18.45 9.7125C18.8167 9.20417 19 8.63333 19 8V7H17V10.8ZM11 19V15.9C10.1833 15.7167 9.45417 15.3708 8.8125 14.8625C8.17083 14.3542 7.7 13.7167 7.4 12.95C6.15 12.8 5.10417 12.2542 4.2625 11.3125C3.42083 10.3708 3 9.26667 3 8V7C3 6.45 3.19583 5.97917 3.5875 5.5875C3.97917 5.19583 4.45 5 5 5H7C7 4.45 7.19583 3.97917 7.5875 3.5875C7.97917 3.19583 8.45 3 9 3H15C15.55 3 16.0208 3.19583 16.4125 3.5875C16.8042 3.97917 17 4.45 17 5H19C19.55 5 20.0208 5.19583 20.4125 5.5875C20.8042 5.97917 21 6.45 21 7V8C21 9.26667 20.5792 10.3708 19.7375 11.3125C18.8958 12.2542 17.85 12.8 16.6 12.95C16.3 13.7167 15.8292 14.3542 15.1875 14.8625C14.5458 15.3708 13.8167 15.7167 13 15.9V19H16C16.2833 19 16.5208 19.0958 16.7125 19.2875C16.9042 19.4792 17 19.7167 17 20C17 20.2833 16.9042 20.5208 16.7125 20.7125C16.5208 20.9042 16.2833 21 16 21H8C7.71667 21 7.47917 20.9042 7.2875 20.7125C7.09583 20.5208 7 20.2833 7 20C7 19.7167 7.09583 19.4792 7.2875 19.2875C7.47917 19.0958 7.71667 19 8 19H11Z"
                fill="white"
            />
        </svg>
    );
};

export const ViewListIconActive = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.49984 16.6654H16.6665C17.1248 16.6654 17.5172 16.5022 17.8436 16.1758C18.17 15.8494 18.3332 15.457 18.3332 14.9987V13.332H7.49984V16.6654ZM1.6665 6.66536H5.83317V3.33203H3.33317C2.87484 3.33203 2.48248 3.49523 2.15609 3.82161C1.8297 4.148 1.6665 4.54036 1.6665 4.9987V6.66536ZM1.6665 11.6654H5.83317V8.33203H1.6665V11.6654ZM3.33317 16.6654H5.83317V13.332H1.6665V14.9987C1.6665 15.457 1.8297 15.8494 2.15609 16.1758C2.48248 16.5022 2.87484 16.6654 3.33317 16.6654ZM7.49984 11.6654H18.3332V8.33203H7.49984V11.6654ZM7.49984 6.66536H18.3332V4.9987C18.3332 4.54036 18.17 4.148 17.8436 3.82161C17.5172 3.49523 17.1248 3.33203 16.6665 3.33203H7.49984V6.66536Z"
                fill="#2073F6"
            />
        </svg>
    );
};

export const ViewListIcon = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.49984 16.6654H16.6665C17.1248 16.6654 17.5172 16.5022 17.8436 16.1758C18.17 15.8494 18.3332 15.457 18.3332 14.9987V13.332H7.49984V16.6654ZM1.6665 6.66536H5.83317V3.33203H3.33317C2.87484 3.33203 2.48248 3.49523 2.15609 3.82161C1.8297 4.148 1.6665 4.54036 1.6665 4.9987V6.66536ZM1.6665 11.6654H5.83317V8.33203H1.6665V11.6654ZM3.33317 16.6654H5.83317V13.332H1.6665V14.9987C1.6665 15.457 1.8297 15.8494 2.15609 16.1758C2.48248 16.5022 2.87484 16.6654 3.33317 16.6654ZM7.49984 11.6654H18.3332V8.33203H7.49984V11.6654ZM7.49984 6.66536H18.3332V4.9987C18.3332 4.54036 18.17 4.148 17.8436 3.82161C17.5172 3.49523 17.1248 3.33203 16.6665 3.33203H7.49984V6.66536Z"
                fill="#797776"
            />
        </svg>
    );
};

export const ViewGridIcon = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 9.16667V2.5H9.16667V9.16667H2.5ZM2.5 17.5V10.8333H9.16667V17.5H2.5ZM10.8333 9.16667V2.5H17.5V9.16667H10.8333ZM10.8333 17.5V10.8333H17.5V17.5H10.8333Z"
                fill="#797776"
            />
        </svg>
    );
};

export const ViewGridIconActive = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 9.16667V2.5H9.16667V9.16667H2.5ZM2.5 17.5V10.8333H9.16667V17.5H2.5ZM10.8333 9.16667V2.5H17.5V9.16667H10.8333ZM10.8333 17.5V10.8333H17.5V17.5H10.8333Z"
                fill="#2073F6"
            />
        </svg>
    );
};

export const OrderManagementIcon = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.275 18.125L16.85 17.7C16.7 17.55 16.5208 17.475 16.3125 17.475C16.1042 17.475 15.925 17.55 15.775 17.7C15.625 17.85 15.55 18.025 15.55 18.225C15.55 18.425 15.625 18.6 15.775 18.75L16.75 19.725C16.9 19.875 17.075 19.95 17.275 19.95C17.475 19.95 17.65 19.875 17.8 19.725L20.225 17.35C20.375 17.2 20.45 17.0208 20.45 16.8125C20.45 16.6042 20.375 16.425 20.225 16.275C20.075 16.125 19.8958 16.05 19.6875 16.05C19.4792 16.05 19.3 16.125 19.15 16.275L17.275 18.125ZM7 9H17C17.2833 9 17.5208 8.90417 17.7125 8.7125C17.9042 8.52083 18 8.28333 18 8C18 7.71667 17.9042 7.47917 17.7125 7.2875C17.5208 7.09583 17.2833 7 17 7H7C6.71667 7 6.47917 7.09583 6.2875 7.2875C6.09583 7.47917 6 7.71667 6 8C6 8.28333 6.09583 8.52083 6.2875 8.7125C6.47917 8.90417 6.71667 9 7 9ZM18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23ZM3 5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V10.375C21 10.6583 20.9042 10.8958 20.7125 11.0875C20.5208 11.2792 20.2833 11.375 20 11.375C19.7167 11.375 19.4792 11.2792 19.2875 11.0875C19.0958 10.8958 19 10.6583 19 10.375V5H5V19.05H11.075C11.1083 19.3 11.1583 19.55 11.225 19.8C11.2917 20.05 11.3667 20.2917 11.45 20.525C11.5333 20.7083 11.5 20.8542 11.35 20.9625C11.2 21.0708 11.0583 21.0583 10.925 20.925L10.85 20.85C10.75 20.75 10.6333 20.7 10.5 20.7C10.3667 20.7 10.25 20.75 10.15 20.85L9.35 21.65C9.25 21.75 9.13333 21.8 9 21.8C8.86667 21.8 8.75 21.75 8.65 21.65L7.85 20.85C7.75 20.75 7.63333 20.7 7.5 20.7C7.36667 20.7 7.25 20.75 7.15 20.85L6.35 21.65C6.25 21.75 6.13333 21.8 6 21.8C5.86667 21.8 5.75 21.75 5.65 21.65L4.85 20.85C4.75 20.75 4.63333 20.7 4.5 20.7C4.36667 20.7 4.25 20.75 4.15 20.85L3 22V5ZM7 17H10.375C10.6583 17 10.8958 16.9042 11.0875 16.7125C11.2792 16.5208 11.375 16.2833 11.375 16C11.375 15.7167 11.2792 15.4792 11.0875 15.2875C10.8958 15.0958 10.6583 15 10.375 15H7C6.71667 15 6.47917 15.0958 6.2875 15.2875C6.09583 15.4792 6 15.7167 6 16C6 16.2833 6.09583 16.5208 6.2875 16.7125C6.47917 16.9042 6.71667 17 7 17ZM7 13H13.55C13.8333 13 14.0708 12.9042 14.2625 12.7125C14.4542 12.5208 14.55 12.2833 14.55 12C14.55 11.7167 14.4542 11.4792 14.2625 11.2875C14.0708 11.0958 13.8333 11 13.55 11H7C6.71667 11 6.47917 11.0958 6.2875 11.2875C6.09583 11.4792 6 11.7167 6 12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13Z"
                fill="#313030"
            />
        </svg>
    );
};

export const OrderManagementIconActive = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.275 18.125L16.85 17.7C16.7 17.55 16.5208 17.475 16.3125 17.475C16.1042 17.475 15.925 17.55 15.775 17.7C15.625 17.85 15.55 18.025 15.55 18.225C15.55 18.425 15.625 18.6 15.775 18.75L16.75 19.725C16.9 19.875 17.075 19.95 17.275 19.95C17.475 19.95 17.65 19.875 17.8 19.725L20.225 17.35C20.375 17.2 20.45 17.0208 20.45 16.8125C20.45 16.6042 20.375 16.425 20.225 16.275C20.075 16.125 19.8958 16.05 19.6875 16.05C19.4792 16.05 19.3 16.125 19.15 16.275L17.275 18.125ZM17 9C17.2833 9 17.5208 8.90417 17.7125 8.7125C17.9042 8.52083 18 8.28333 18 8C18 7.71667 17.9042 7.47917 17.7125 7.2875C17.5208 7.09583 17.2833 7 17 7H7C6.71667 7 6.47917 7.09583 6.2875 7.2875C6.09583 7.47917 6 7.71667 6 8C6 8.28333 6.09583 8.52083 6.2875 8.7125C6.47917 8.90417 6.71667 9 7 9H17ZM18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23ZM3 21.875V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V10.5C21 10.7833 20.8833 11.0125 20.65 11.1875C20.4167 11.3625 20.1583 11.4083 19.875 11.325C19.4083 11.2083 18.9333 11.125 18.45 11.075C17.9667 11.025 17.4833 11 17 11H7C6.71667 11 6.47917 11.0958 6.2875 11.2875C6.09583 11.4792 6 11.7167 6 12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13H13.1C12.8167 13.2833 12.5542 13.5917 12.3125 13.925C12.0708 14.2583 11.8583 14.6167 11.675 15H7C6.71667 15 6.47917 15.0958 6.2875 15.2875C6.09583 15.4792 6 15.7167 6 16C6 16.2833 6.09583 16.5208 6.2875 16.7125C6.47917 16.9042 6.71667 17 7 17H11.075C11.0417 17.1667 11.0208 17.3292 11.0125 17.4875C11.0042 17.6458 11 17.8167 11 18C11 18.4333 11.0417 18.8583 11.125 19.275C11.2083 19.6917 11.3167 20.1083 11.45 20.525C11.5333 20.7083 11.5 20.8542 11.35 20.9625C11.2 21.0708 11.0583 21.0583 10.925 20.925L10.85 20.85C10.75 20.75 10.6333 20.7 10.5 20.7C10.3667 20.7 10.25 20.75 10.15 20.85L9.35 21.65C9.25 21.75 9.13333 21.8 9 21.8C8.86667 21.8 8.75 21.75 8.65 21.65L7.85 20.85C7.75 20.75 7.63333 20.7 7.5 20.7C7.36667 20.7 7.25 20.75 7.15 20.85L6.35 21.65C6.25 21.75 6.13333 21.8 6 21.8C5.86667 21.8 5.75 21.75 5.65 21.65L4.85 20.85C4.75 20.75 4.63333 20.7 4.5 20.7C4.36667 20.7 4.25 20.75 4.15 20.85L3.35 21.65L3 21.875Z"
                fill="white"
            />
        </svg>
    );
};

export const WarningIconRed = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
        >
            <path
                d="M20 36.6673C29.2048 36.6673 36.6667 29.2054 36.6667 20.0007C36.6667 10.7959 29.2048 3.33398 20 3.33398C10.7953 3.33398 3.33337 10.7959 3.33337 20.0007C3.33337 29.2054 10.7953 36.6673 20 36.6673Z"
                stroke="#E33333"
                strokeWidth="3.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 26.6667V20"
                stroke="#E33333"
                strokeWidth="3.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 13.334H20.0167"
                stroke="#E33333"
                strokeWidth="3.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ThreeDotIcon = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0026 6.66634C10.9193 6.66634 11.6693 5.91634 11.6693 4.99967C11.6693 4.08301 10.9193 3.33301 10.0026 3.33301C9.08594 3.33301 8.33594 4.08301 8.33594 4.99967C8.33594 5.91634 9.08594 6.66634 10.0026 6.66634ZM10.0026 8.33301C9.08594 8.33301 8.33594 9.08301 8.33594 9.99967C8.33594 10.9163 9.08594 11.6663 10.0026 11.6663C10.9193 11.6663 11.6693 10.9163 11.6693 9.99967C11.6693 9.08301 10.9193 8.33301 10.0026 8.33301ZM8.33594 14.9997C8.33594 14.083 9.08594 13.333 10.0026 13.333C10.9193 13.333 11.6693 14.083 11.6693 14.9997C11.6693 15.9163 10.9193 16.6663 10.0026 16.6663C9.08594 16.6663 8.33594 15.9163 8.33594 14.9997Z"
                fill="#797776"
            />
        </svg>
    );
};

export const ThreeDotIconHorizontal = ({ width = 24, height = 24 }: { width?: number | string; height?: number | string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.99992 8.33398C4.08325 8.33398 3.33325 9.08398 3.33325 10.0007C3.33325 10.9173 4.08325 11.6673 4.99992 11.6673C5.91659 11.6673 6.66659 10.9173 6.66659 10.0007C6.66659 9.08398 5.91659 8.33398 4.99992 8.33398ZM14.9999 8.33398C14.0833 8.33398 13.3333 9.08398 13.3333 10.0007C13.3333 10.9173 14.0833 11.6673 14.9999 11.6673C15.9166 11.6673 16.6666 10.9173 16.6666 10.0007C16.6666 9.08398 15.9166 8.33398 14.9999 8.33398ZM8.33325 10.0007C8.33325 9.08398 9.08325 8.33398 9.99992 8.33398C10.9166 8.33398 11.6666 9.08398 11.6666 10.0007C11.6666 10.9173 10.9166 11.6673 9.99992 11.6673C9.08325 11.6673 8.33325 10.9173 8.33325 10.0007Z"
                fill="#797776"
            />
        </svg>
    );
};

export const SearchAddressIcon = () => {
    return (
        <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.8818 9.76316L9.04233 7.92105C9.56788 7.23684 9.88321 6.39474 9.88321 5.44737C9.88321 3.28947 8.14891 1.5 5.94161 1.5C3.73431 1.5 2 3.23684 2 5.44737C2 7.65789 3.73431 9.39474 5.94161 9.39474C6.88759 9.39474 7.72848 9.07895 8.41169 8.55263L10.2511 10.3947C10.3562 10.5 10.4613 10.5 10.5664 10.5C10.6715 10.5 10.7766 10.4474 10.8818 10.3947C11.0394 10.1842 11.0394 9.92105 10.8818 9.76316ZM5.99417 8.60526C4.25986 8.60526 2.89344 7.18421 2.89344 5.5C2.89344 3.76316 4.31241 2.39474 5.99417 2.39474C7.72847 2.39474 9.09489 3.81579 9.09489 5.5C9.09489 7.18421 7.67592 8.60526 5.99417 8.60526Z"
                fill="white"
            />
        </svg>
    );
};

export const IconPdf = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <g clipPath="url(#clip0_12309_98927)">
                <path
                    d="M13.5959 0.0996094H4.68387C4.01187 0.0996094 3.46387 0.643609 3.46387 1.31961V18.8796C3.46387 19.5516 4.00787 20.0996 4.68387 20.0996H17.7519C18.4239 20.0996 18.9719 19.5556 18.9719 18.8796V4.14762L13.5959 0.0996094Z"
                    fill="url(#paint0_linear_12309_98927)"
                />
                <path
                    d="M17.7518 20.2H4.68377C3.95577 20.2 3.36377 19.608 3.36377 18.88V1.32C3.36377 0.592 3.95577 0 4.68377 0H13.6318L19.0718 4.1V18.88C19.0718 19.608 18.4798 20.2 17.7518 20.2ZM4.68377 0.2C4.06777 0.2 3.56377 0.7 3.56377 1.32V18.88C3.56377 19.496 4.06377 20 4.68377 20H17.7518C18.3678 20 18.8718 19.5 18.8718 18.88V4.2L13.5638 0.2H4.68377Z"
                    fill="url(#paint1_radial_12309_98927)"
                />
                <path
                    d="M14.3439 4.1715L18.9719 4.14752L13.6119 0.103516L13.5879 3.60352C13.5879 3.90352 14.0079 4.1715 14.3439 4.1715Z"
                    fill="#CCD3EB"
                />
                <path
                    d="M9.95592 9.13211H2.23191C1.50791 9.13211 0.919922 8.54412 0.919922 7.82012V5.72412C0.919922 5.00012 1.50791 4.41211 2.23191 4.41211H9.95592C10.6799 4.41211 11.2679 5.00012 11.2679 5.72412V7.82012C11.2679 8.54412 10.6799 9.13211 9.95592 9.13211Z"
                    fill="url(#paint2_linear_12309_98927)"
                />
                <path
                    d="M4.75992 6.71973C4.68792 6.84773 4.57991 6.95172 4.43191 7.03172C4.28391 7.11172 4.09992 7.15172 3.87992 7.15172H3.47191V8.11973H2.81592V5.42773H3.87992C4.09592 5.42773 4.27593 5.46373 4.42393 5.53973C4.57193 5.61573 4.68392 5.71573 4.75592 5.84773C4.83192 5.97973 4.86791 6.12772 4.86791 6.29572C4.86791 6.44772 4.83192 6.58773 4.75992 6.71973ZM4.10791 6.53973C4.16791 6.47973 4.19992 6.39972 4.19992 6.29172C4.19992 6.18372 4.16791 6.09973 4.10791 6.04373C4.04791 5.98373 3.95191 5.95572 3.82791 5.95572H3.47191V6.63172H3.82791C3.95591 6.62772 4.04791 6.59973 4.10791 6.53973Z"
                    fill="#F5F7FF"
                />
                <path
                    d="M6.96393 5.59191C7.17593 5.70391 7.33992 5.86393 7.45592 6.06393C7.57192 6.26793 7.63191 6.49993 7.63191 6.76793C7.63191 7.03193 7.57192 7.26393 7.45592 7.46793C7.33992 7.67193 7.17592 7.83193 6.95992 7.94393C6.74792 8.05593 6.49992 8.11191 6.21992 8.11191H5.21191V5.41992H6.21992C6.50392 5.42392 6.75193 5.47991 6.96393 5.59191ZM6.75592 7.34393C6.89592 7.20793 6.96393 7.01593 6.96393 6.76793C6.96393 6.51993 6.89592 6.32793 6.75592 6.18793C6.61592 6.04793 6.42392 5.97992 6.17592 5.97992H5.86393V7.54393H6.17592C6.42392 7.54793 6.61592 7.47993 6.75592 7.34393Z"
                    fill="#F5F7FF"
                />
                <path
                    d="M9.74809 5.42393V5.94793H8.65209V6.51592H9.47209V7.02393H8.65209V8.11191H7.99609V5.41992H9.74809V5.42393Z"
                    fill="#F5F7FF"
                />
                <path
                    d="M14.9921 15.5635C14.9521 15.4115 14.8601 15.3035 14.7281 15.2195C14.6121 15.1435 14.4841 15.0955 14.3481 15.0635C14.0321 14.9875 13.7121 14.9795 13.3881 14.9955C13.1641 15.0075 12.9401 15.0315 12.7161 15.0595C12.6961 15.0635 12.6801 15.0595 12.6641 15.0435C12.6481 15.0235 12.6281 15.0075 12.6121 14.9915C12.2841 14.6595 12.0201 14.2795 11.7801 13.8835C11.7641 13.8595 11.7721 13.8395 11.7801 13.8195C11.8561 13.5875 11.9201 13.3515 11.9721 13.1155C12.0281 12.8355 12.0641 12.5555 12.0721 12.3235C12.0761 12.1395 12.0601 12.0115 12.0281 11.8835C11.9921 11.7435 11.9361 11.6115 11.8441 11.5035C11.7001 11.3355 11.5161 11.2635 11.3001 11.2835C11.0841 11.3075 10.9321 11.4315 10.8481 11.6315C10.7881 11.7755 10.7681 11.9315 10.7641 12.0875C10.7601 12.2955 10.7881 12.4995 10.8321 12.7035C10.8921 12.9915 10.9881 13.2675 11.1041 13.5355C11.1161 13.5595 11.1161 13.5835 11.1081 13.6075C11.0801 13.6835 11.0521 13.7595 11.0281 13.8315C10.8041 14.4755 10.5281 15.0995 10.2081 15.7035C10.1921 15.7355 10.1721 15.7555 10.1401 15.7675C10.0481 15.8035 9.95606 15.8435 9.86806 15.8875C9.56006 16.0275 9.26008 16.1795 8.98008 16.3715C8.82408 16.4755 8.68007 16.5915 8.55607 16.7355C8.49207 16.8115 8.43608 16.8915 8.40008 16.9835C8.28808 17.2675 8.41608 17.5355 8.64408 17.6515C8.84008 17.7515 9.04006 17.7635 9.24806 17.6995C9.42406 17.6475 9.57608 17.5515 9.72008 17.4355C9.92808 17.2675 10.1041 17.0675 10.2681 16.8555C10.4841 16.5755 10.6761 16.2795 10.8521 15.9755C10.8681 15.9475 10.8881 15.9315 10.9201 15.9235C11.0681 15.8755 11.2161 15.8275 11.3641 15.7835C11.7361 15.6715 12.1121 15.5795 12.4921 15.5035C12.5281 15.4955 12.5521 15.5035 12.5801 15.5275C12.7881 15.7035 13.0081 15.8595 13.2561 15.9795C13.5761 16.1395 13.9081 16.2355 14.2681 16.2395C14.4081 16.2395 14.5481 16.2275 14.6761 16.1755C14.8121 16.1195 14.9161 16.0275 14.9641 15.8875C14.9681 15.8795 14.9721 15.8675 14.9761 15.8595C15.0161 15.7675 15.0201 15.6675 14.9921 15.5635ZM10.0161 16.2155C9.82407 16.5275 9.61608 16.8235 9.36008 17.0835C9.28408 17.1635 9.20006 17.2355 9.10806 17.2955C9.06006 17.3275 9.00406 17.3555 8.94806 17.3715C8.88006 17.3915 8.81608 17.3715 8.76008 17.3315C8.72408 17.3075 8.70806 17.2715 8.70806 17.2275C8.70806 17.1755 8.72408 17.1275 8.74408 17.0835C8.77608 17.0195 8.82006 16.9675 8.86806 16.9155C8.95206 16.8275 9.04408 16.7515 9.14408 16.6835C9.41608 16.4915 9.71207 16.3395 10.0161 16.2035C10.0161 16.1955 10.0241 16.1955 10.0281 16.1995C10.0281 16.2075 10.0241 16.2155 10.0161 16.2155ZM11.1201 12.0715C11.1241 11.9795 11.1361 11.8875 11.1641 11.7995C11.1761 11.7555 11.1961 11.7115 11.2321 11.6795C11.3201 11.5955 11.4401 11.6115 11.5001 11.7155C11.5281 11.7635 11.5401 11.8155 11.5481 11.8675C11.5681 11.9755 11.5561 12.0835 11.5441 12.1915C11.5161 12.5115 11.4521 12.8235 11.3481 13.1275C11.3441 13.1435 11.3361 13.1595 11.3321 13.1755C11.2601 13.0115 11.2121 12.8435 11.1761 12.6755C11.1361 12.4755 11.1121 12.2755 11.1201 12.0715ZM11.1601 15.4275C11.3281 15.0755 11.4681 14.7235 11.5961 14.3595C11.6881 14.5035 11.7841 14.6395 11.8841 14.7675C11.9841 14.8955 12.0921 15.0195 12.2121 15.1435C11.8601 15.2395 11.5081 15.3115 11.1601 15.4275ZM14.2601 15.8275C14.1681 15.8755 14.0721 15.8835 13.9761 15.8675C13.7921 15.8355 13.6201 15.7715 13.4561 15.6915C13.2801 15.6075 13.1121 15.5075 12.9601 15.3835C12.9481 15.3755 12.9321 15.3715 12.9321 15.3515C13.0201 15.3355 13.1081 15.3275 13.1961 15.3195C13.3601 15.3035 13.5241 15.2955 13.6881 15.2955C13.8241 15.2955 13.9601 15.3075 14.0921 15.3275C14.1641 15.3395 14.2281 15.3635 14.2881 15.4035C14.4441 15.5075 14.4241 15.7435 14.2601 15.8275Z"
                    fill="#CCD3EB"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_12309_98927"
                    x1="11.2183"
                    y1="-0.276291"
                    x2="11.2183"
                    y2="22.9456"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F6F8FC" />
                    <stop
                        offset="0.4077"
                        stopColor="#F4F6FB"
                    />
                    <stop
                        offset="0.6069"
                        stopColor="#ECEFF8"
                    />
                    <stop
                        offset="0.7604"
                        stopColor="#DFE4F3"
                    />
                    <stop
                        offset="0.8905"
                        stopColor="#CDD4EB"
                    />
                    <stop
                        offset="0.8948"
                        stopColor="#CCD3EB"
                    />
                </linearGradient>
                <radialGradient
                    id="paint1_radial_12309_98927"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11.2182 10.1) scale(9.04657 9.04657)"
                >
                    <stop stopColor="#F6F8FC" />
                    <stop
                        offset="0.5267"
                        stopColor="#DEE2F2"
                    />
                    <stop
                        offset="1"
                        stopColor="#CCD3EB"
                    />
                </radialGradient>
                <linearGradient
                    id="paint2_linear_12309_98927"
                    x1="6.09324"
                    y1="4.41491"
                    x2="6.09324"
                    y2="9.13097"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF8077" />
                    <stop
                        offset="1"
                        stopColor="#FA0F00"
                    />
                </linearGradient>
                <clipPath id="clip0_12309_98927">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const UnBlockIcon = () => {
    return (
        <svg
            width="20"
            height="36"
            viewBox="0 0 20 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.2 23L14.3 24.1C13.9 24.4 13.4 24.7 12.9 24.9C12 25.3 11 25.5 10 25.5C9 25.5 8 25.3 7.1 24.9C6.2 24.5 5.4 24 4.7 23.3C4 22.6 3.5 21.8 3.1 20.9C2.7 20 2.5 19 2.5 18C2.5 17 2.7 16 3.1 15.1C3.3 14.6 3.6 14.1 3.9 13.7L5 14.8C4.7 15.2 4.5 15.6 4.3 16C4.1 16.7 4 17.3 4 18C4 19.7 4.6 21.1 5.7 22.3C6.9 23.4 8.3 24 10 24C10.7 24 11.3 23.9 12 23.7C12.4 23.5 12.8 23.3 13.2 23ZM16.9 15.1C16.5 14.2 16 13.4 15.3 12.7C14.6 12 13.8 11.5 12.9 11.1C12 10.7 11 10.5 10 10.5C9 10.5 8 10.7 7.1 11.1C6.6 11.3 6.1 11.6 5.7 11.9L6.8 13C7.2 12.7 7.6 12.5 8 12.3C8.7 12.1 9.3 12 10 12C11.7 12 13.1 12.6 14.3 13.7C15.4 14.9 16 16.3 16 18C16 18.7 15.9 19.3 15.7 20C15.5 20.5 15.3 20.9 15 21.3L16.1 22.4C16.4 22 16.7 21.5 16.9 21C17.3 20.1 17.5 19.1 17.5 18.1C17.5 17.1 17.3 16 16.9 15.1Z"
                fill="#313030"
            />
        </svg>
    );
};

export const BlockIcon = () => {
    return (
        <svg
            width="20"
            height="36"
            viewBox="0 0 20 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 25.5C8.9625 25.5 7.9875 25.3031 7.075 24.9094C6.1625 24.5156 5.36875 23.9813 4.69375 23.3063C4.01875 22.6313 3.48438 21.8375 3.09063 20.925C2.69688 20.0125 2.5 19.0375 2.5 18C2.5 16.9625 2.69688 15.9875 3.09063 15.075C3.48438 14.1625 4.01875 13.3688 4.69375 12.6938C5.36875 12.0188 6.1625 11.4844 7.075 11.0906C7.9875 10.6969 8.9625 10.5 10 10.5C11.0375 10.5 12.0125 10.6969 12.925 11.0906C13.8375 11.4844 14.6313 12.0188 15.3063 12.6938C15.9813 13.3688 16.5156 14.1625 16.9094 15.075C17.3031 15.9875 17.5 16.9625 17.5 18C17.5 19.0375 17.3031 20.0125 16.9094 20.925C16.5156 21.8375 15.9813 22.6313 15.3063 23.3063C14.6313 23.9813 13.8375 24.5156 12.925 24.9094C12.0125 25.3031 11.0375 25.5 10 25.5ZM10 24C10.675 24 11.325 23.8906 11.95 23.6719C12.575 23.4531 13.15 23.1375 13.675 22.725L5.275 14.325C4.8625 14.85 4.54688 15.425 4.32813 16.05C4.10938 16.675 4 17.325 4 18C4 19.675 4.58125 21.0938 5.74375 22.2563C6.90625 23.4188 8.325 24 10 24ZM14.725 21.675C15.1375 21.15 15.4531 20.575 15.6719 19.95C15.8906 19.325 16 18.675 16 18C16 16.325 15.4188 14.9062 14.2563 13.7438C13.0938 12.5813 11.675 12 10 12C9.325 12 8.675 12.1094 8.05 12.3281C7.425 12.5469 6.85 12.8625 6.325 13.275L14.725 21.675Z"
                fill="#313030"
            />
        </svg>
    );
};

export function TransactionsIconActive({ width = 24, height = 24, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 12H20V8H4V12Z"
                fill="white"
            />
        </svg>
    );
}

export function TransactionsIcon({ width = 24, height = 24, fill = '#313030', fillSub = '#1AB474' }: SVGProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6ZM4 8H20V6H4V8ZM4 12V18H20V12H4Z"
                fill="#313030"
            />
        </svg>
    );
}

export function StarRatingIcon({ width = '35', height = '33', fill = '#D9D9D9' }: SVGProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_i_2679_5043)">
                <path d="M15.2442 1.34298C15.8668 -0.448141 18.3998 -0.448142 19.0224 1.34298L21.8489 9.47428C22.1235 10.2644 22.8609 10.8002 23.6972 10.8172L32.304 10.9926C34.1998 11.0312 34.9826 13.4403 33.4715 14.5859L26.6116 19.7867C25.945 20.2921 25.6634 21.159 25.9056 21.9596L28.3984 30.1993C28.9475 32.0143 26.8982 33.5032 25.3418 32.4202L18.2757 27.5031C17.589 27.0253 16.6776 27.0253 15.9909 27.5031L8.92484 32.4202C7.36836 33.5032 5.31907 32.0143 5.86817 30.1994L8.36099 21.9596C8.60323 21.159 8.32157 20.2921 7.65498 19.7867L0.795065 14.5859C-0.716 13.4403 0.0667605 11.0312 1.96261 10.9926L10.5694 10.8172C11.4057 10.8002 12.1431 10.2644 12.4177 9.47428L15.2442 1.34298Z" fill={fill}/>
            </g>
            <defs>
                <filter id="filter0_i_2679_5043" x="0" y="-25" width="34.2666" height="57.7871" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="-25"/>
                    <feGaussianBlur stdDeviation="50"/>
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.616667 0 0 0 0 0.616667 0 0 0 0 0.616667 0 0 0 0.08 0"/>
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2679_5043"/>
                </filter>
            </defs>
        </svg>
    );
}
